<div
  class="business-navbar__section"
  (click)="toggle()"
  [class.business-navbar__section--opened]="opened$ | async"
  [style.padding-left.px]="indentation * 24"
>
  <i
    class="material-icons business-navbar__section__right-arrow"
    [ngClass]="{
      'business-navbar__section__right-arrow--opened': (opened$ | async)
    }"
  >
    arrow_right
  </i>
  <div class="business-navbar__text">{{ text$ | async }}</div>
  <atlas-chip *ngIf="_section.chipContent" [text]="_section.chipContent | translate" [isNavChip]="true"></atlas-chip>
</div>
<div class="business-navbar__section-items-wrapper">
  <div #section class="business-navbar__section-items">
    <ng-content></ng-content>
  </div>
</div>
